<template>
  <div class="bigBox">
    <!-- <div class="topStyle">
      <div class="iconStyle" @click="back">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="typeTitle">人车登记</div>
    </div> -->
    <div class="searchBox">
      <el-form :model="dataFrom" ref="dataFrom" :rules="rules" label-width="110px">
        <el-form-item label="姓名:" prop="applyUname">
          <el-input v-model.trim="dataFrom.applyUname" maxlength="10" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="mobile">
          <el-input v-model.trim="dataFrom.mobile" maxlength="11" v-number-input.float="0" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="车牌号:" prop="vhcNo">
          <el-input placeholder="请输入车牌号" v-model="dataFrom.vhcNo" ></el-input>
        </el-form-item>
        <el-form-item label="来访时间:" prop="visitTime">
          <el-date-picker
            v-model="dataFrom.visitTime"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="来访部门:" prop="visitDepmetcode">
          <el-select v-model="dataFrom.visitDepmetcode" @change="selectChange" placeholder="请选择来访部门">
            <el-option v-for="item in visitDepmetList" :label="item.name" :key="item.id"
              :value="item.code" :style="{ fontSize: 17 + 'px' }"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来访事由:">
          <el-input type="textarea" maxlength="50" v-model.trim="dataFrom.visitDesc" style="width:230px;" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="行驶证(副页):" class="is-required">
          <div class="box">
            <div class="imgBox">
              <uploadImgs :imgList.sync='imgList' style="margin:0;"></uploadImgs>
            </div>
          </div>
        </el-form-item>
        <div class="btnBox">
          <el-button class="btnStyle" type="primary" @click="saveFn('dataFrom')">提 交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { visitauditAdd,getDepartmentByTenantCode } from '@/api/vgs-driver'
import uploadImgs from '@/components/uploadImgs.vue'
const vhsrule =
  /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
export default {
  name: 'personnelNoLogin',
  components: {
     uploadImgs
   },
  data () {
    return {
      dataFrom:{
        applyType:'2',
        visitTime:'',
        tenantCode:this.$route.query.tenantCode,
        tenantName:this.$route.query.tenantName
      },
      visitDepmetList:[],
      rules: {
        applyUname: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          this.rule.mobile
        ],
        visitTime: [
          { required: true, message: '请输入来访时间', trigger: 'blur' }
        ],
        visitDepmetcode: [
          { required: true, message: '请输入来访部门', trigger: 'blur' }
        ],
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ]
      },
      imgList:[]
    }
  },
  created () {
    document.title = '人车登记';
    const newdateTime = new Date().getTime()
    this.dataFrom.visitTime = this.dateFormat(newdateTime)
    console.log(this.dataFrom.visitTime,'2222')
    this.getDepartmentByTenantCode()
  },
  methods: {
    // 获取部门
    getDepartmentByTenantCode(){
      getDepartmentByTenantCode({
        tenantCode:this.dataFrom.tenantCode
      }).then(res => {
        console.log(res,'res')
        this.visitDepmetList = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    vhcInput (val) {
      if (!vhsrule.test(val)) {
        this.$message({ message: '请输入正确的车牌号', type: 'error' })
      }
    },
    selectChange(val){
      console.log(val,'val')
      this.visitDepmetList.forEach(item=>{
        if(item.code == val){
          this.$set(this.dataFrom,'visitDepmetname',item.name)
        }
      })
    },
    saveFn(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.dataFrom,'this.dataFrom')
          let imgfile = new FormData()
          this.dataFrom.visitTime = this.dateFormat(this.dataFrom.visitTime)
          if (this.imgList.length == 0 || this.imgList[0] == null) {
            this.$message({
              message: '行驶证不能为空',
              type: 'error'
            })
            return
          }
          if (!vhsrule.test(this.dataFrom.vhcNo)) {
            this.$message({ message: '请输入正确的车牌号', type: 'error' })
            return
          }
          if(this.imgList.length > 0){
            imgfile.set('vhcLicense', this.imgList[0].raw)
          }
          imgfile.set('params', JSON.stringify(this.dataFrom))
          console.log(imgfile,'imgfile')
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          visitauditAdd(imgfile).then(res => {
            loading.close()
            this.$message({
              message: '登记成功',
              type: 'success'
            })
            this.back()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    dateFormat(timestamp) {
      let date = new Date(timestamp);    //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-';
      let M = ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) :
              (date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s;
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 删除图片
    remove (file) {
      console.log(file,'file')
    },
  },
}
</script>
<style scoped lang='less'>
.bigBox{
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
}
.topStyle{
  display: flex;
  margin-top: 30px;
}
.iconStyle{
  position: absolute;
  left: 20px;
  font-size: 20px;
  font-weight: bold;
}
.typeTitle{
  margin: 0 auto;
  font-weight: 700;
}
.searchBox{
  width: 99%;
  margin: 40px auto;
}
.btnBox{
  width: 90%;
  margin: 0 auto;
}
.btnStyle{
  width: 100%;
  border-radius: 20px;
  font-size: 20px;
}
/deep/.el-input .el-input__inner{
  width: 230px !important;
  font-size: 17px;
}
.box{
  .imgBox{
    /deep/.el-upload--picture-card{
      width: 150px;
      height: 150px;
    }
  }
  .hidden /deep/.el-upload--picture-card{
    display: none;
  }
  /deep/.el-upload--picture-card {
    background: url(../../../assets/images/upload1.png) no-repeat;
    background-size: cover;
    background-position: center center;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
    width: 150px;
    height: 150px;
  }
}
/deep/.el-form-item__label{
  font-size: 17px;
}
</style>